// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ControllerLabelsMessage, ControllerLabelsMessageT, verifyControllerLabelsMessage } from './controller-labels-message';
import { ElevatorControllerInfoContent, unionToElevatorControllerInfoContent, unionListToElevatorControllerInfoContent } from './elevator-controller-info-content';
import { FirmwareVersionMessage, FirmwareVersionMessageT, verifyFirmwareVersionMessage } from './firmware-version-message';
import { FloorLabelMessage, FloorLabelMessageT, verifyFloorLabelMessage } from './floor-label-message';
import { FloorLabelsDataMessage, FloorLabelsDataMessageT, verifyFloorLabelsDataMessage } from './floor-labels-data-message';


export class ElevatorControllerInfoMessage implements flatbuffers.IUnpackableObject<ElevatorControllerInfoMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorControllerInfoMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorControllerInfoMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorControllerInfoMessage):ElevatorControllerInfoMessage {
  return (obj || new ElevatorControllerInfoMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorControllerInfoMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorControllerInfoMessage):ElevatorControllerInfoMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorControllerInfoMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

messageType():ElevatorControllerInfoContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : ElevatorControllerInfoContent.NONE;
}

message<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startElevatorControllerInfoMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessageType(builder:flatbuffers.Builder, messageType:ElevatorControllerInfoContent) {
  builder.addFieldInt8(0, messageType, ElevatorControllerInfoContent.NONE);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, messageOffset, 0);
}

static endElevatorControllerInfoMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // message
  return offset;
}

static createElevatorControllerInfoMessage(builder:flatbuffers.Builder, messageType:ElevatorControllerInfoContent, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  ElevatorControllerInfoMessage.startElevatorControllerInfoMessage(builder);
  ElevatorControllerInfoMessage.addMessageType(builder, messageType);
  ElevatorControllerInfoMessage.addMessage(builder, messageOffset);
  return ElevatorControllerInfoMessage.endElevatorControllerInfoMessage(builder);
}

unpack(): ElevatorControllerInfoMessageT {
  return new ElevatorControllerInfoMessageT(
    this.messageType(),
    (() => {
      const temp = unionToElevatorControllerInfoContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: ElevatorControllerInfoMessageT): void {
  _o.messageType = this.messageType();
  _o.message = (() => {
      const temp = unionToElevatorControllerInfoContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}



unpackFields(...fields: string[]): ElevatorControllerInfoMessageT {
  const t = new ElevatorControllerInfoMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message_type')) {
    t.messageType = this.messageType();
  }
  if (fieldSet.has('message')) {
    t.message = (() => {
      const temp = unionToElevatorControllerInfoContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
  }
  return t;
}
}

export class ElevatorControllerInfoMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public messageType: ElevatorControllerInfoContent = ElevatorControllerInfoContent.NONE,
  public message: ControllerLabelsMessageT|FirmwareVersionMessageT|FloorLabelMessageT|FloorLabelsDataMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  if (this.message === null || this.message === undefined) {
    throw new Error('Required field "message" is not set');
  }
  const message = builder.createObjectOffset(this.message);

  return ElevatorControllerInfoMessage.createElevatorControllerInfoMessage(builder,
    this.messageType,
    message
  );
}

clone(): ElevatorControllerInfoMessageT {
  const obj = new ElevatorControllerInfoMessageT();
  obj.messageType = this.messageType;
  obj.message = this.message !== null && typeof (this.message as any).clone === 'function' ? (this.message as any).clone() : this.message;
  return obj;
}

equals(other: ElevatorControllerInfoMessageT): boolean {
  if (this.messageType !== other.messageType) return false;
  if (this.message !== null && other.message !== null) {
    if (typeof (this.message as any).equals === 'function') {
      if (!(this.message as any).equals(other.message)) return false;
    } else if (this.message !== other.message) return false;
  } else if (this.message !== other.message) return false;
  return true;
}
}

export function verifyElevatorControllerInfoMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, 'message');
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // FloorLabelMessage
            { const o = verifier.readInt32(pos); verifyFloorLabelMessage(verifier, pos + o); }
            break;
          case 2: // FirmwareVersionMessage
            { const o = verifier.readInt32(pos); verifyFirmwareVersionMessage(verifier, pos + o); }
            break;
          case 3: // ControllerLabelsMessage
            { const o = verifier.readInt32(pos); verifyControllerLabelsMessage(verifier, pos + o); }
            break;
          case 4: // FloorLabelsDataMessage
            { const o = verifier.readInt32(pos); verifyFloorLabelsDataMessage(verifier, pos + o); }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, 'message');
  } finally {
    verifier.popDepth();
  }
}
